export default __webpack_public_path__ + "static/media/example_company_2.27f7752a.webp";